<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="100px"
    >
      <el-form-item label="appid">
        <el-input
          v-model="app_id"
          style="width: 500px;"
          :disabled="type == 2"
        ></el-input>
      </el-form-item>
      <el-form-item label="封面">
        <img
          v-if="updataimg!=''"
          :src="updataimg"
          style="width: 80px;height: 80px;"
          alt=""
        >
        <el-upload
          ref="upload"
          class="upload-demo"
          action="#"
          :http-request="httpRequest"
          :multiple="true"
          :show-file-list="false"
          :limit="100"
        >
          <el-button
            size="small"
            type="primary"
            plain
          >点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="小程序名字">
        <el-input
          v-model="account_name"
          style="width: 500px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="简介">
        <el-input
          v-model="blurb"
          style="width: 500px;"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="热度">
        <el-input-number
          v-model="heat"
          :min="1"
          label="描述文字"
        ></el-input-number>
        /万+人玩过
      </el-form-item> -->
      <el-form-item label="小程序标签">
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)"
        >
          {{tag}}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        >
        </el-input>
        <el-button
          v-else
          class="button-new-tag"
          size="small"
          @click="showInput"
        >+ 新增标签</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { gameSettingstore, gameSettingupdate, getQcConfig } from '@/api/sourceminiprogram.js'
import { uploadFilesimg } from '@/utils/ObjectStorage.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      app_id: '',
      account_name: '',
      updataimg: '',
      cover: '',
      type: null,
      id: '',
      domain: '',
      item: {},
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      blurb: ''
      // heat: 10
    }
  },
  created() {},
  mounted() {},
  methods: {
    sumbit() {
      if (this.app_id === '') {
        this.$message.error('请输入小程序app_id')
        return
      }
      if (this.updataimg === '') {
        this.$message.error('请选择封面')
        return
      }
      if (this.account_name === '') {
        this.$message.error('请输入小程序名字')
        return
      }
      if (this.type === 1) {
        gameSettingstore({
          app_id: this.app_id,
          name: this.account_name,
          cover: this.cover,
          blurb: this.blurb,
          label: this.dynamicTags
          // heat: this.heat
        }).then(res => {
          this.$message({
            message: '新增成功',
            type: 'success'
          })
          this.$emit('updata')
        })
      } else {
        gameSettingupdate({
          app_id: this.app_id,
          name: this.account_name,
          cover: this.cover,
          blurb: this.blurb,
          label: this.dynamicTags,
          // heat: this.heat,
          id: this.id
        }).then(res => {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.$emit('updata')
        })
      }
    },
    send(type, item) {
      this.type = type
      if (this.type === 2) {
        this.cover = item.cover
        this.app_id = item.app_id
        this.account_name = item.name
        this.updataimg = item.url
        // this.heat = item.heat
        this.dynamicTags = item.label
        this.blurb = item.blurb
        this.id = item.id
      }
      this.getconfig()
    },
    async getconfig() {
      const res = await getQcConfig()
      this.config = res.data
    },
    async httpRequest(e) {
      // console.log('e:', e)
      const _this = this
      const fileIfon = e.file
      console.log('fileIfon:', fileIfon)
      const arr = []
      const img = new Image()
      // const videoWidth = 0
      // const videoHeight = 0
      const fileType = fileIfon.type
      console.log('fileType:', fileType)

      if (fileType.startsWith('image/')) {
        // const temporary = e.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        // temporary !== '多张' && (img.src = temporary)
        // this.temporary = temporary
        const programimg = window.URL.createObjectURL(fileIfon)
        img.src = programimg
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        console.log('fileIfon.size:', fileIfon.size)
        const maxSize = 20 * 1024 * 1024 // 设置最大文件大小为50MB
        if (fileIfon.size > maxSize) {
          return this.$message('上传图片太大')
        }
        _this.showProgress = true
        this.percentage = 0
        console.log('fileIfon:', fileIfon)
        await uploadFilesimg(
          fileIfon,
          (num, id) => {
            this.percentage = num
          },
          'operation',
          this.config
        )
          .then(res => {
            console.log('res-------:', res.files[0].options, this.config.domain)
            this.updataimg = this.config.domain + res.files[0].options.Key
            this.cover = res.files[0].options.Key
          })
          .catch(err => {
            console.log('err:-----', err)
          })
      } else {
        this.$message({
          message: '不支持的文件类型',
          type: 'error'
        })
      }
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
